import { render } from "./tanMemberAddEdit.vue?vue&type=template&id=74a50a66&scoped=true"
import script from "./tanMemberAddEdit.vue?vue&type=script&lang=js"
export * from "./tanMemberAddEdit.vue?vue&type=script&lang=js"

import "./tanMemberAddEdit.vue?vue&type=style&index=0&id=74a50a66&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74a50a66"]])

export default __exports__